import {doGet, doPost, doFormPost} from './Base';


const getPreviewCard = async (domain, card_id) => {
  const url = '/domains/' + domain + '/preview_card/' + card_id;
  return await doGet(url);
};

const getPreviewCards = async (domain) => {
  const url = '/domains/' + domain + '/preview_card';
  return await doGet(url);
};

const savePreviewCard = async (form) => {
  let domain = form.elements.namedItem('domain').value;
  let url = '/domains/' + domain + '/preview_card';
  let card_id = form.elements.namedItem('id').value;
  if (card_id) {
    url += '/' + card_id;
  }
  return await doFormPost(url, form);
}

const setAsDefault = async (domain, card_id) => {
  let url = '/domains/' + domain + '/preview_card/' + card_id + '/setdefault';
  await doPost(url, {});
}


export {getPreviewCards, savePreviewCard, getPreviewCard, setAsDefault};
export default getPreviewCards;
